export enum FilterTypes {
  All      = 'filter_by_all',
  Active   = 'filter_by_started',
  Inactive = 'filter_by_completed',
}

export enum SortTypes {
  Alphabetical = 'sort_by_alphabetical-order',
  Progress     = 'sort_by_progress',
  DueDate      = 'sort_by_due-date',
  None         = 'sort_by_none',
}

export enum ShowContentTypes {
  All      = 'all',
  Courses  = 'courses',
  Programs = 'programs',
  Packages = 'packages',
}

export enum AssignedFilterTypes {
  All      = 'all',
  Assigned = 'assigned',
}